<template>
  <div style="display: inline">
    <el-button icon="el-icon-s-check" type="primary" @click="handleShow" size="mini" style="background: #e03f3d">
      审核确认
    </el-button>

    <el-dialog title="审核确认" :visible.sync="show" width="500px" center custom-class="default-table"
               :close-on-press-escape="false" :close-on-click-modal="false">
      <p style="line-height: 40px;">当前已选择：【<b style="color: darkred;">{{ form.ids.length }}</b>】条认领数据，</p>
      <div style="margin: 10px 0;">
        设置<b style="color: darkred;">核算归属月份</b>为
        <el-date-picker
            v-model="form.date_check"
            type="month"
            value-format="yyyy-MM"
            :default-value="defaultDisplayDate()"
            :picker-options="pickerOptions"
            placeholder="核算月份"
            style="width: calc(100% - 129px)"
        />
      </div>
      <div>
        备注
        <el-input v-model="form.remark" maxlength="20" placeholder="可输入备注信息" show-word-limit clearable
                  style="width: calc(100% - 31px)"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <button-submit button-txt="确 认" type="primary" @click.native.prevent="handleSure"/>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {liveGuaranteeConfirm} from "../../../../api/liveGuarantee";

const ModelForm = {
  ids: [],
  date_check: null,
  remark: null,
}
export default {
  name: 'LiveGuaranteeConfirm',
  props: {
    getSelection: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      show: false,
      form: {...{}, ...ModelForm},
      pickerOptions: {
        highlightedDates: []
      }
    }
  },
  methods: {
    handleShow: function () {
      this.form = {...{}, ...ModelForm}
      const selection = this.getSelection()
      if (!selection.length) {
        this.$message.warning('请先选择行数据')
        return
      }
      this.form.ids = selection.map(_ => {
        return _.id
      })
      this.show = true
    },
    handleSure: async function () {
      if (!this.form.date_check) {
        this.$message.warning('核算归属月份不能为空！')
        return;
      }
      this.form.date_check = this.form.date_check.substring(0, 7) + '-01'
      const {success} = await liveGuaranteeConfirm(this.form)
      if (success) {
        this.show = false
        this.$message.success('操作成功！')
        this.$emit('success')
      }
    },
    defaultDisplayDate() {
      const today = new Date()
      const currentYear = today.getFullYear()
      const currentMonth = today.getMonth() // 0-11 (0代表1月)
      // 判断当前是否是1月
      if (currentMonth === 0) {
        // 是1月时：展示上一年的月份
        this.pickerOptions.highlightedDates = [new Date(currentYear - 1, 11)]
        return new Date(currentYear - 1, 11)
      } else {
        // 非1月时：展示当前年的月份
        this.pickerOptions.highlightedDates = [new Date(currentYear, currentMonth - 1)]
        return new Date(currentYear, currentMonth - 1)
      }
    }
  }
}
</script>

<style>
/** 全局样式 **/
.el-month-table {
  /** 当前日期样式调整 **/
  td.today .cell {
    color: #606266;
    font-weight: normal;
  }
  /** 默认日期标红样式 **/
  td.default .cell {
    color: #ff3176;
    font-weight: bold;
  }
}
</style>
<style scoped>

</style>
